"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validator = _interopRequireDefault(require("validator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isLength = function isLength(message, options) {
  return function (_ref) {
    var field = _ref.field;

    if (!field.value) {
      return true;
    }

    var strValue = field.value;

    if (strValue && _typeof(strValue) === 'object') {
      strValue = strValue.value;
    }

    if (strValue && typeof strValue !== 'string' && typeof strValue === 'number') {
      strValue = strValue.toString();
    }

    var isValid = _validator.default.isLength(strValue, options);

    var errorMessage = message ? message.replace('{min}', options.min).replace('{max}', options.max) : "Please enter value of length between ".concat(options.min, " and ").concat(options.max);
    return [isValid, errorMessage];
  };
};

var _default = isLength;
exports.default = _default;
//# sourceMappingURL=isLength.js.map